import { render, staticRenderFns } from "./crmRemoteProject.vue?vue&type=template&id=935e0776&"
import script from "./crmRemoteProject.vue?vue&type=script&lang=js&"
export * from "./crmRemoteProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports